import { useTranslation } from 'react-i18next';
import { Button } from '@shared/components/ui/button';

interface ErrorStateProps {
  error: Error;
  onRetry: () => void;
  className?: string;
  title?: string;
}

// 🎯 Single Responsibility Principle (SRP)
// Este componente SOLO maneja estados de error
export const ErrorState = ({ error, onRetry, className = 'h-64', title }: ErrorStateProps) => {
  const { t } = useTranslation('shopsModule');

  // 🎯 Usar título por defecto del módulo si no se proporciona uno
  const defaultTitle = title || t('error.loading.title', 'Error al cargar tiendas');

  return (
    <div className={'flex items-center justify-center ' + className}>
      <div className="text-center">
        <div className="text-warning text-4xl mb-4">⚠️</div>
        <h3 className="text-lg font-semibold text-title mb-2">{defaultTitle}</h3>
        <p className="text-subtext mb-4">{error.message}</p>
        <Button onClick={onRetry} variant="primary" data-testid="retry-button" className="mx-auto">
          {t('error.loading.retry', 'Reintentar')}
        </Button>
      </div>
    </div>
  );
};
